import { Logs } from 'components/Logs';
import { useRecruitmentModal } from './context';

export function RecruitmentEvents() {
  const { recruitment } = useRecruitmentModal();

  return <Logs logs={recruitment?.events || []} />;
}
